import { Container, Row, Col } from "react-bootstrap"
import { useState } from 'react';

import ModalPrivacidad from './ModalPrivacidad'

import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import iconoCorreo from '../assets/img/icono_correo.png'
import ReactLogo from '../logo.svg';
import "./Footer.css";

export const Footer = () => {
    const [showPrivacy, setShowPrivacy] = useState(false);
    return (
        <>
            <footer className="footer">
                <Container>
                    <Row className="align-items-center">
                        <Col md={12} className="text-sm-center">
                            <div className="social-icon d-flex justify-content-center gap-4">
                                <a className="icono_footer" href="https://www.linkedin.com/in/j-penarrubia/" target="_blank" rel="noopener noreferrer">
                                    <img src={navIcon1} alt="linkedIn" />
                                </a>
                                <a className="icono_footer" href="https://github.com/j-penarrubia" target="_blank" rel="noopener noreferrer">
                                    <img src={navIcon2} alt="gitHub" />
                                </a>
                                <a className="icono_footer" href="mailto:penarrubia.92@gmail.com?subject=Contacto%20portfolio"
                                    target="_blank" rel="noopener noreferrer">
                                    <img className="correo" src={iconoCorreo} alt="Correo" />
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <hr />
                    <Row> 
                        <Col md={4} sm={12} className="text-sm-center"><p>Hecho con React 19<img src={ReactLogo} alt="React" className="react-logo" style={{ width: '30px', height: '30px' }} /></p></Col>
                        <Col md={4} className="text-sm-center"><a onClick={() => setShowPrivacy(true)} className="legal-link">Política de privacidad</a></Col>
                        <Col md={4} className="text-sm-center"> <p> ©2026 Juan Ángel Peñarrubia </p></Col>
                    </Row>
                </Container>
            </footer>
            {showPrivacy && (
                <ModalPrivacidad showPrivacy={showPrivacy} onClose={() => setShowPrivacy(false)} />
            )}
        </>
    )
}